import React, { useState, useEffect } from 'react';
import { ProgressProduct } from '../../../../../_mexablock/helpers/components/ProgressProduct';
import {
  formatDateMonth,
  formatPrice,
  KTSVG,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import { TablePackage } from './TablePackage';
import { getPackageById } from '../../../../service/inventario/productos';

type Props = {
  listaPaquetes: any;
  onSearchFilter: (values: any) => void;
  onReloadData: (reload: boolean) => void;
};

const TablaGeneral: React.FC<Props> = ({
  listaPaquetes,
  onSearchFilter,
  onReloadData,
}) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [dataInventario, setDataInventario] = useState<any[]>([]);
  const [selectedPackageId, setSelectedPackageId] = useState<number | null>(
    null
  );
  const [selectedPackage, setSelectedPackage] = useState<any | null>(null);
  const [initFilterValues, setInitFilterValues] = useState({
    status_id: 0,
    user_id: '',
    init_date: '',
    end_date: '',
    filter: 0,
  });
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑ]*$/;
    if (regex.test(e.target.value)) {
      setInputValue(e.target.value);
    }
  };

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };

  const fetchPost = async () => {
    const filters = {
      package_id: selectedPackageId,
      ...initFilterValues,
    };

    try {
      const sends = await getPackageById(filters);
      if (sends) {
        setDataInventario(sends);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const [sortedPaquetes, setSortedPaquetes] = useState<any[]>([]);
  const [isAsc, setIsAsc] = useState(true);

  useEffect(() => {
    if (Array.isArray(listaPaquetes) && listaPaquetes.length > 0) {
      setSortedPaquetes([...listaPaquetes]);
      setSelectedPackageId(listaPaquetes[0].id);
      setSelectedPackage(listaPaquetes[0]);
    } else {
      setSortedPaquetes([]);
      setSelectedPackageId(null);
      setSelectedPackage(null);
    }
  }, [listaPaquetes]);

  useEffect(() => {
    if (initFilterValues && selectedPackageId) {
      fetchPost();
    }
  }, [initFilterValues, selectedPackageId]);

  useEffect(() => {
    onSearchFilter(searchFilter);
  }, [searchFilter]);

  return (
    <>
      <div className="card mt-5">
        <div className="card-body p-0">
          <div className="row">
            <div className="col-3 border pb-4">
              <div className="row p-3 ms-1">
                <div className="col-10">
                  <div className="d-flex align-items-center position-relative me-4">
                    <span
                      className="position-absolute ms-3"
                      style={{ zIndex: 10 }}
                    >
                      <i className="bi bi-search fs-4 text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-solid ps-9"
                      placeholder="Buscar"
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div
                  className="col-2 position-relative"
                  style={{
                    height: '60px',
                    padding: '6px 0 0 0',
                    margin: '0',
                  }}
                >
                  <button
                    type="button"
                    className="position-absolute ms-3 btn btn-light p-2 rounded"
                    onClick={() => {
                      const sorted = [...sortedPaquetes].sort((a, b) =>
                        isAsc ? a.id - b.id : b.id - a.id
                      );
                      setSortedPaquetes(sorted);
                      setIsAsc(!isAsc);

                      if (sorted.length > 0) {
                        setSelectedPackageId(sorted[0].id);
                        setSelectedPackage(sorted[0]);
                      }
                    }}
                  >
                    <KTSVG
                      path="/media/icons/duotune/arrows/arr093.svg"
                      svgClassName="w-100 h-100"
                    />
                  </button>
                </div>
              </div>
              <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                {sortedPaquetes?.length > 0 ? (
                  sortedPaquetes?.map((item: any) => (
                    <div
                      key={item.id}
                      className={`text-center ms-7 me-3 cursor-pointer ${
                        selectedPackageId === item.id ? 'bg-primary' : ''
                      }`}
                      onClick={() => {
                        setSelectedPackageId(item.id);
                        setSelectedPackage(item);
                      }}
                      style={{
                        borderRadius: '0.475rem',
                        transition: 'background-color 0.2s',
                      }}
                    >
                      <div className="border p-2 h-125px d-flex align-items-center">
                        <div className="w-100">
                          <div className="text-start">
                            <span
                              className={`fw-bolder fs-5 ${
                                selectedPackageId === item.id
                                  ? 'text-white'
                                  : ''
                              }`}
                            >
                              {item.type_stock_id === 1 ? 'SIM' : 'E-SIM'}
                            </span>
                          </div>
                          <div className="row mt-2">
                            <div className="col text-start d-flex flex-column">
                              <span
                                className={`fw-bolder fs-7 ${
                                  selectedPackageId === item.id
                                    ? 'text-white'
                                    : ''
                                }`}
                              >
                                {item.total_stock
                                  ? `${item.total_stock} pza`
                                  : 'Sin piezas'}
                              </span>
                              <span
                                className={`fs-7 ${
                                  selectedPackageId === item.id
                                    ? 'text-white'
                                    : ''
                                }`}
                              >
                                Fecha ingreso
                              </span>
                              <span
                                className={`fw-bolder fs-7 ${
                                  selectedPackageId === item.id
                                    ? 'text-white'
                                    : ''
                                }`}
                              >
                                {formatDateMonth(item.createdAt)}
                              </span>
                            </div>
                            <div className="col text-end d-flex flex-column">
                              <span
                                className={`fw-bolder fs-7 ${
                                  selectedPackageId === item.id
                                    ? 'text-white'
                                    : ''
                                }`}
                              >
                                {item.total_price_output
                                  ? formatPrice(
                                      Number(item.total_price_output),
                                      'es-MX',
                                      'MXN',
                                      2,
                                      2
                                    )
                                  : ''}
                              </span>
                              <span
                                className={`fs-7 ${
                                  selectedPackageId === item.id
                                    ? 'text-white'
                                    : ''
                                }`}
                              >
                                Ubicación
                              </span>
                              <span
                                className={`fw-bolder fs-7 ${
                                  selectedPackageId === item.id
                                    ? 'text-white'
                                    : ''
                                }`}
                              >
                                {item.location}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-muted text-center mt-10">
                    No hay productos disponibles
                  </div>
                )}
              </div>
            </div>
            <div className="col-9 pb-4">
              <TablePackage
                className=""
                id_package={selectedPackage?.id}
                dataInventario={dataInventario}
                onCleanFilter={(updateGrid: boolean) => {
                  if (updateGrid) {
                    onReloadData(true);
                  }
                }}
                onSearchFilter={handleFilter}
                descripcion={selectedPackage?.description}
                costo={selectedPackage?.total_price_output}
                proveedor={selectedPackage?.provider_id}
                cantidad={selectedPackage?.total_stock}
                tipo_stock={
                  selectedPackage?.type_stock_id === 1 ? 'SIM' : 'E-SIM'
                }
                disponible={selectedPackage?.available}
                image={selectedPackage?.image}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { TablaGeneral };
